"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewModeValueMixin = exports.StyledViewModeValue = exports.StyledInputHocInputContainer = exports.StyledInputHocError = exports.StyledInputHoc = exports.EllipsisMixin = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../../ykb-styled-components"));
var _StyledTextInput = require("../../TextInput/StyledTextInput");
var _col = require("../../Grid/col");
var _StyledRadio = require("../../Radio/StyledRadio");
var _StyledCheckbox = require("../../Checkbox/StyledCheckbox");
var _StyledDatePicker = require("../../DatePicker/StyledDatePicker");
var _StyledSelect = require("../../Select/StyledSelect");
var _StyledTextarea = require("../../Textarea/StyledTextarea");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ViewModeValueMixin = exports.ViewModeValueMixin = (0, _ykbStyledComponents.css)(["background:", ";padding:", ";min-height:", ";border-radius:", ";border:", ";line-height:", ";max-height:", ";overflow:auto;font-weight:", ";word-break:break-all;white-space:pre-line;"], function (props) {
  return props.theme.form.viewMode.backgroundColor;
}, function (props) {
  return props.theme.form.padding;
}, function (props) {
  return props.size === 'large' ? props.theme.input.sizes.large.height : props.size === 'small' ? props.theme.input.sizes.small.height : props.theme.input.sizes.medium.height;
}, function (props) {
  return props.theme.input.sizes.medium.borderRadius;
}, function (props) {
  return props.theme.form.viewMode.border;
}, function (props) {
  return props.size === 'large' ? props.theme.form.viewMode.lineHeight.lg : props.size === 'small' ? props.theme.form.viewMode.lineHeight.sm : props.theme.form.viewMode.lineHeight.md;
}, function (props) {
  return props.theme.form.viewMode.maxHeight;
}, function (props) {
  return props.theme.form.viewMode.fontWeight;
});
var StyledViewModeValue = exports.StyledViewModeValue = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-coemau-0"
})(["", ";height:", "px;max-height:", "px;&.view-mode-value-CurrencyInput{text-align:right;}", " ", ""], ViewModeValueMixin, function (props) {
  return props.viewModeHeight && props.viewModeHeight;
}, function (props) {
  return props.viewModeHeight && props.viewModeHeight;
}, function (props) {
  return props.hidden && (0, _ykbStyledComponents.css)(["display:none;"]);
}, function (props) {
  return props.layout === 'vertical' && (0, _ykbStyledComponents.css)(["vertical-align:top;"]);
});
var StyledInputHocInputContainer = exports.StyledInputHocInputContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-coemau-1"
})(["display:flex;flex-direction:column;", ""], function (props) {
  return props.viewMode && props.customViewMode === false && (0, _ykbStyledComponents.css)(["display:none !important;"]);
});
var StyledInputHocError = exports.StyledInputHocError = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-coemau-2"
})(["display:block;color:", ";font-size:", ";line-height:", ";padding:", ";"], function (props) {
  return props.theme.form.error.color;
}, function (props) {
  return props.theme.form.error.fontSize;
}, function (props) {
  return props.theme.form.error.lineHeight;
}, function (props) {
  return props.theme.form.error.padding;
});

// TODO add select picker etc. ref for border color
var StyledInputHoc = exports.StyledInputHoc = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-coemau-3"
})(["position:relative;", "{min-width:auto;width:100%;}", " ", ""], _StyledTextInput.StyledInput, function (props) {
  return props.hasError && (0, _ykbStyledComponents.css)(["", "{border-color:", " !important;&:focus,&.focus{box-shadow:none;}}", "{border-color:", " !important;[class*='-inner']{border-color:", ";}}", "{[class*='-inner']{border-color:", ";}}", "{[class*='-selector']{border-color:", ";}}", "{border-color:", ";&:focus{box-shadow:none;}}", "{box-shadow:none;}", ".focus-all{border-color:", " !important;> *:last-child{border-color:", " !important;}> *:first-child{border-color:", " !important;}}", ",", "{border-color:", ";box-shadow:none;}"], _StyledTextInput.StyledInput, function (props) {
    return props.theme.color.danger6;
  }, _StyledRadio.StyledRadio, function (props) {
    return props.theme.color.danger6;
  }, function (props) {
    return props.theme.color.danger6;
  }, _StyledCheckbox.StyledCheckbox, function (props) {
    return props.theme.color.danger6;
  }, _StyledSelect.StyledSelect, function (props) {
    return props.theme.color.danger6;
  }, _StyledTextarea.StyledTextarea, function (props) {
    return props.theme.color.danger6;
  }, _StyledTextInput.StyledInputGroup, _StyledTextInput.StyledInputGroup, function (props) {
    return props.theme.color.danger6;
  }, function (props) {
    return props.theme.color.danger6;
  }, function (props) {
    return props.theme.color.danger6;
  }, _StyledDatePicker.StyledRangePicker, _StyledDatePicker.StyledDatePicker, function (props) {
    return props.theme.color.danger6;
  });
}, function (props) {
  return props.ellipsis && (0, _ykbStyledComponents.css)(["", "{", ";}"], StyledViewModeValue, EllipsisMixin);
});
var EllipsisMixin = exports.EllipsisMixin = (0, _ykbStyledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);